import { TrendingDown } from "lucide-react";

interface QuantityTiersProps {
  currentQty: number;
  /** Unit net price for a given quantity, or null when it cannot be calculated. */
  unitFor: (qty: number) => number | null;
  onSelect: (qty: number) => void;
  tiers?: number[];
}

const DEFAULT_TIERS = [50, 100, 200, 300, 500, 1000];

/** Visible quantity thresholds – shows how much the unit price drops at bigger runs. */
const QuantityTiers = ({ currentQty, unitFor, onSelect, tiers = DEFAULT_TIERS }: QuantityTiersProps) => {
  const currentUnit = currentQty > 0 ? unitFor(currentQty) : null;
  if (!currentUnit) return null;

  const rows = tiers
    .filter((q) => q > currentQty)
    .map((q) => {
      const unit = unitFor(q);
      if (!unit) return null;
      const drop = ((currentUnit - unit) / currentUnit) * 100;
      return drop > 0.5 ? { qty: q, unit, drop } : null;
    })
    .filter(Boolean) as { qty: number; unit: number; drop: number }[];

  if (rows.length === 0) return null;

  return (
    <div className="border-t border-primary-foreground/10 pt-4 mb-4">
      <p className="text-primary-foreground/60 text-xs font-bold tracking-widest uppercase mb-3 flex items-center gap-2">
        <TrendingDown className="w-4 h-4 text-accent" aria-hidden="true" />
        Progi ilościowe
      </p>
      <ul className="space-y-2">
        {rows.slice(0, 4).map((r) => (
          <li key={r.qty}>
            <button
              type="button"
              onClick={() => onSelect(r.qty)}
              className="w-full flex items-center justify-between gap-3 rounded-lg border border-primary-foreground/10 bg-primary px-3 py-2.5 text-left hover:border-accent transition-colors"
            >
              <span className="text-primary-foreground text-sm">
                Przy <strong>{r.qty} szt.</strong> cena jednostkowa spada o{" "}
                <strong className="text-accent">{r.drop.toFixed(0)}%</strong>
              </span>
              <span className="text-primary-foreground/50 text-xs whitespace-nowrap">
                {r.unit.toFixed(2)} zł / szt.
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuantityTiers;
